import { atom } from "jotai";

export enum THEME_CHOICE {
  THEME_DEFAULT = "theme_default",
  THEME_AMETHYST = "theme_amethyst",
}

export const THEME_NAMES: Record<THEME_CHOICE, string> = {
  [THEME_CHOICE.THEME_DEFAULT]: "Obsidian",
  [THEME_CHOICE.THEME_AMETHYST]: "Amethyst",
};

export const themeAtom = atom(THEME_CHOICE.THEME_DEFAULT);
